/* Service that provide methods to operate on query strings */
export class QueryStringParserService {
  /* Converts a well formed query string of form "?key=value&key2=value2" to an object
   * with the key value pairs populated { key: value, key2: value2 }
   */
  public static getQueryParameters(searchQuery: string) {
    if (searchQuery == null) return {};

    let decodedQuery = decodeURIComponent(searchQuery);
    let result = {} as any;

    if (decodedQuery != '' && decodedQuery[0] === '?') {
      decodedQuery = decodedQuery.substring(1);
    }
    if (decodedQuery == '') {
      return result;
    }
    let splitKeyValuePairs = decodedQuery.split('&');

    for (var i = 0; i < splitKeyValuePairs.length; i++) {
      let keyValuePair = splitKeyValuePairs[i].split('=');

      if (keyValuePair.length == 2) {
        result[keyValuePair[0]] = keyValuePair[1];
      } else if (keyValuePair.length == 1) {
        result[keyValuePair[0]] = 'true';
      }
    }

    return result;
  }

  public static getValue(key: string): string {
    let result = QueryStringParserService.getQueryParameters(window.location.search);

    if (result[key]) {
      return result[key];
    } else {
      return 'false';
    }
  }

  public static constainsQuery(key: string): boolean {
    const result = QueryStringParserService.getQueryParameters(window.location.search);

    if (result[key]) {
      return true;
    } else {
      return false;
    }
  }

  public static getTestTopics(): string {
    let result = QueryStringParserService.getQueryParameters(window.location.search);

    if (result['testTopics']) {
      return result['testTopics'];
    } else {
      return 'false';
    }
  }
}
